export const defaultCloud = process.env.NODE_ENV == "local" ? "local" : "aws";

export const termsOfServiceHref = "https://www.decodable.co/legal/tos";

export const searchParamNames = {
  selectedPlanId: "selected_plan_id",
};

export const taskSizes = {
  small: {
    name: "Small",
    spec: {
      cpu: "0.25 cores",
      mem: "512 GB",
    },
  },
  medium: {
    name: "Medium",
    spec: {
      cpu: "0.5 cores",
      mem: "1024 GB",
    },
  },
  large: {
    name: "Large",
    spec: {
      cpu: "1 core",
      mem: "2048 GB",
    },
  },
} as const;

export type TaskSize = (typeof taskSizes)[keyof typeof taskSizes];

export const plans = [
  {
    id: "free",
    name: "Developer",
    isSelfService: true,
    requiresPayment: false,
    taskPrices: [
      {
        taskSize: taskSizes.small,
        hourlyPrice: "Free",
      },
      {
        taskSize: taskSizes.medium,
        hourlyPrice: "Free",
      },
    ],
    description: [
      "4 tasks for pipelines and connections",
      "7 day per stream / 10GB total retention",
      "Community Slack support",
    ],
    cta: "Choose Plan",
    link: "./select?plan=free",
  },
  {
    id: "on_demand",
    name: "Team",
    isSelfService: true,
    requiresPayment: true,
    taskPrices: [
      {
        taskSize: taskSizes.small,
        hourlyPrice: "$0.10/hour",
      },
      {
        taskSize: taskSizes.medium,
        hourlyPrice: "$0.20/hour",
      },
      {
        taskSize: taskSizes.large,
        hourlyPrice: "$0.40/hour",
      },
    ],
    description: [
      "Unlimited tasks for pipelines and connections - pay only for what you use",
      "7 day per stream / 100GB total retention",
      "Slack and email support",
    ],
    cta: "Choose Plan",
    link: "./select?plan=on_demand",
  },
  {
    id: "enterprise" as const,
    name: "Enterprise",
    isSelfService: false,
    requiresPayment: true,
    taskPrices: [
      {
        taskSize: taskSizes.small,
        hourlyPrice: "Custom",
      },
      {
        taskSize: taskSizes.medium,
        hourlyPrice: "Custom",
      },
      {
        taskSize: taskSizes.large,
        hourlyPrice: "Custom",
      },
    ],
    description: [
      "Unlimited tasks for pipelines and connections - reserved capacity",
      "Unlimited stream retention",
      "Enterprise identity provider support (ADFS, Okta, Ping Identity, and more)",
      "Dedicated support",
      "Optional isolated tenancy add-on",
    ],
    cta: "Contact Sales",
    link: "https://www.decodable.co/contact",
  },
] as const;

export const selfServicePlans = plans.filter((p) => p.isSelfService);

export type Plan = (typeof plans)[number];
